import Header from "../components/Header";
import SchoolsHero from "../components/schools/SchoolsHero";
import SchoolsProblem from "../components/schools/SchoolsProblem";
import SchoolsSolution from "../components/schools/SchoolsSolution";
import SchoolsHowItWorks from "../components/schools/SchoolsHowItWorks";
import SchoolsImplementation from "../components/schools/SchoolsImplementation";
import SchoolsOutcomes from "../components/schools/SchoolsOutcomes";
import SchoolsSELAlignment from "../components/schools/SchoolsSELAlignment";
import SchoolsMovement from "../components/schools/SchoolsMovement";
import SchoolsCTA from "../components/schools/SchoolsCTA";

export default function Schools() {
    return (
        <div className="min-h-screen bg-[#f8f4ea] text-black">
            <Header />

            <main className="overflow-hidden border-t-[4px] border-black">
                <SchoolsHero />
                <SchoolsProblem />
                <SchoolsSolution />
                <SchoolsHowItWorks />
                <SchoolsImplementation />
                <SchoolsOutcomes />
                <SchoolsSELAlignment />
                <SchoolsMovement />
                <SchoolsCTA />
            </main>
        </div>
    );
}